import "./App.css";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// components
import TokenExpirationHandler from "pages/login/token-expiration";
import { Login } from "pages/login";
import MySnackbar from "components/mui/snackbar/snakbar";
import ProtectedRoute from "components/protected-route/protected-route";
import { Subscriptions } from "pages/subscriptions";
// store
import store from "store/index";
import Entities from "pages/members/entitiy-members";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <TokenExpirationHandler />
        <div className="App">
          <MySnackbar />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/entities"
              element={
                <ProtectedRoute target="entities">
                  <Entities />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscriptions"
              element={
                <ProtectedRoute target="subscriptions">
                  <Subscriptions />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
